<template>
  <div class="sidebar">
    <!-- <el-menu class="sidebar-el-menu" :default-active="onRoutes" :collapse="collapse" background-color="#463132" 
          text-color="#ffffff" active-text-color="#E40613" unique-opened router>-->
        <el-menu class="sidebar-el-menu" :default-active="onRoutes" :collapse="collapse" background-color="#00162a"
            text-color="#ffffff" unique-opened router @select="openSubMenu">
            <template v-for="menu in menus">
              <template v-if="menu.children">
                <el-submenu :index="menu.resourcename" :key="menu.resourcename">
                  <template slot="title">
                    <i :class="getMenuIcon(menu.icon)"></i>
                    <span>&nbsp;{{menu.resourceinfo}}</span>
                  </template>
                  <el-menu-item v-for="(child, childIndex) in menu.children" :key="childIndex" :index="child.resourcename">
                    {{child.resourceinfo}}
                    <!--<router-link :to="children.path">{{children.meta.title}}</router-link>-->
                  </el-menu-item>
                </el-submenu>
              </template>
              <template v-else>
                <el-menu-item :index="menu.resourcename" :key="menu.resourcename">
                  <i :class="getMenuIcon(menu.icon)"></i>
                  <span>&nbsp;{{menu.resourceinfo}}</span>
                </el-menu-item>
              </template>
            </template>
        </el-menu>
    </div>
</template>

<script>
  import bus from '../../../common/js/bus';
  export default {
  name: 'AsideDom',
  data(){
    return {
      collapse: false,
      isCollapse: false,
      isUniqueOpened: true,
      isRouter: true,
      menus:[]
    };
  },
  methods: {
    //初始化菜单
    initMenu(){
      let vm = this;
      vm.$axios.get('/resource/menuTree/' + localStorage.getItem('module')).then(function (res) {
        vm.menus = res.data.result; 
      }.bind(this), function (error) {
        console.log(error)
      })
    },
    getMenuIcon(value) {
      return "iconfont " + value;
    },
    // 这里控制新标签页打开摇号菜单
    openSubMenu(index, indexPath) {
      if (index === "/lottery") {
        let routeData = this.$router.resolve({ path: "/lottery" })
        window.open(routeData.href, "_blank")
      } else if (index === "/lotteries") {
        let routeData = this.$router.resolve({ path: "/lotteries" })
        window.open(routeData.href, "_blank")
      }
    }
  },
  mounted() {
      this.initMenu();
  },
  watch:{
    $route(to, from){
      //清除store中listPagePars 
      let toMatched = to.matched[1].path;
      let fromMatched = from.matched[1].path;
      if((toMatched.endsWith('/')?toMatched.substr(0,toMatched.length-1):toMatched) 
        != (fromMatched.endsWith('/')?fromMatched.substr(0,fromMatched.length-1):fromMatched)){
        if(Object.keys(this.$store.state.listPagePars).length > 0){
          this.$store.commit('RESET_LIST_PAGE_PERS');
        }
      }
    }
  },
  computed:{
      onRoutes(){
        if (this.$route.path.indexOf('/exhprediction/confirm') > -1) {
          if(this.CONSTANT.currentUser.usertype == 'ENG') {
            return '/exhpredictionEN';
          } else {
            return '/exhprediction';
          }
        }
        var subMenus = this.menus;
        var routePath = this.$route.path; 
        if(this.$route.matched.length > 3){
          routePath = this.$route.matched[2].path;
        }else if(this.$route.matched.length == 3 && !this.$route.matched[2].path.endsWith('/')){
          routePath = this.$route.matched[1].path;
        }
        if(routePath.endsWith('/')){
          routePath = routePath.substr(0, routePath.length-1);
        }
        for(var i in subMenus){
          if(routePath == subMenus[i].resourcename){
            this.subMenus = subMenus[i].children;
          }else{
            if(subMenus[i].children != null){
              for(var j in subMenus[i].children){
                if(routePath == subMenus[i].children[j].resourcename){
                  this.subMenus = subMenus[i].children;
                }
              }
            }
          }
          return routePath;
        }

        /**页面为子页面时，选中其父菜单 by li.xue 2019/3/13
        var routeMatched = [];
        var defaultActive = '';
        routeMatched = this.$route.matched
        for (var i in routeMatched) {
          if (routeMatched[i].meta.title) {
            defaultActive = routeMatched[i].path; 
            break;
          }
        }
        return defaultActive;
        */
      }
  },
  created(){
      // 通过 Event Bus 进行组件间通信，来折叠侧边栏
      bus.$on('collapse', msg => {
          this.collapse = msg;
      })
  }
}
</script>

<style scoped>
    .sidebar{
        display: block;
        position: absolute;
        left: 0;
        top: 60px;
        bottom:0;
        overflow-y: scroll;
    }
    .sidebar::-webkit-scrollbar{
        width: 0;
    }
    .sidebar-el-menu:not(.el-menu--collapse){
        width: 240px;
    }
    .sidebar > ul {
        height:100%;
    }
    .el-menu-item i {
      color: #ffffff;
    }
    .el-submenu__title i {
      color: #ffffff;
    }
</style>



// WEBPACK FOOTER //
// src/views/common/layout/AsideDom.vue